<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm" *ngIf="UserModuleAccess==='Full'">
	<div class="row mb-2">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<ng-select id="role" [items]="roleList" bindLabel="role" bindValue="id" [clearable]="false"
				placeholder="Role*" id="role" formControlName="role" appearance="outline">
			</ng-select>
			<p *ngIf="showError('role')" class="text-danger">
				<span *ngIf="f.role.errors?.required">
					Required
				</span>
				<span *ngIf="f.role.errors?.incorrect">
					{{customError.role}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('f_name')}" id="f_name"
					formControlName="f_name" placeholder="">
				<label for="f_name">First Name*</label>
			</div>
			<p *ngIf="showError('f_name')" class="text-danger">
				<span *ngIf="f.f_name.errors?.required">
					Required
				</span>
				<span *ngIf="f.f_name.errors?.incorrect">
					{{customError.f_name}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('l_name')}" id="l_name"
					formControlName="l_name" placeholder="">
				<label for="l_name">Last Name*</label>
			</div>
			<p *ngIf="showError('l_name')" class="text-danger">
				<span *ngIf="f.l_name.errors?.required">
					Required
				</span>
				<span *ngIf="f.l_name.errors?.incorrect">
					{{customError.l_name}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('qualification')}" id="qualification"
					formControlName="qualification" placeholder="">
				<label for="qualification">Qualification</label>
			</div>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('email')}" id="email"
					formControlName="email" placeholder="">
				<label for="email">Email Id*</label>
			</div>
			<p *ngIf="showError('email')" class="text-danger">
				<span *ngIf="f.email.errors?.required">
					Required
				</span>
				<span *ngIf="f.email.errors?.pattern">
					Invalid
				</span>
				<span *ngIf="f.email.errors?.incorrect">
					{{customError.email}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input type="password" class="form-control" [ngClass]="{'is-invalid':showError('password')}"
					id="password" formControlName="password" placeholder="">
				<label for="password">New Password*</label>
			</div>
			<p *ngIf="showError('password')" class="text-danger">
				<span *ngIf="f.password.errors?.required">
					Required
				</span>
			</p>
			<p [ngClass]="f.password.errors?.minlengtherror?'text-danger':'text-success'">
				Must be atleast 8 characters long.
			</p>
			<p [ngClass]="f.password.errors?.specialcharerror?'text-danger':'text-success'">
				Must have atleast 1 special character.
			</p>
			<p [ngClass]="f.password.errors?.uppercaseerror?'text-danger':'text-success'">
				Must have atleast 1 upper case character.
			</p>
			<p [ngClass]="f.password.errors?.lowercaseerror?'text-danger':'text-success'">
				Must have atleast 1 lower case character.
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<label>Stamp:</label>
			<input type="file" id="stamp" name="stamp" (change)="onFileSelect($event)" />
		</div>
		<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
			<label>Two Factor Auth.:</label>
			<br />
			<ng-toggle formControlName="enable2fa" [color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
				[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
				[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
				[labels]="{'unchecked': 'Disable','checked': 'Enable'}" [width]="100"></ng-toggle>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('key_id')}" id="key_id"
					formControlName="key_id" placeholder="">
				<label for="key_id">Key Id</label>
			</div>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>